import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { Button, DropdownMenu } from '@3plearning/react-components';
import TickIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_tick.svg';
import UpArrowIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_up_solid.svg';

import css from './top-level-filter.scss';

import {
    SELECTED_CLASS,
    SELECTED_DATE,
    SELECTED_STUDENT
} from '../../../../../components/report-filters/filter-constants';
import { activeFiltersPropType } from '../../../../../components/report-filters/filter-prop-types';
import { DEFAULT_VALUES, hasValidCourses } from '../../student-helpers';

import ContextModal from '../../../../../components/context-modal/context-modal';

/**
 * SKILL QUESTS MASTERY TOP LEVEL FILTER
 * -----------------------------------------
 * Manages all right hand side functionality of student skill quests
 */
class TopLevelFilter extends Component {
    static propTypes = {
        activeFilters: activeFiltersPropType,
        assignmentResultType: PropTypes.number,
        getStudentSkillQuestsMasteryDataCourse: PropTypes.func,
        skillQuestsMasteryStudentData: PropTypes.object,
        setSelectedPublication: PropTypes.func,
        selectedPublication: PropTypes.shape({
            data: PropTypes.array,
            selected: PropTypes.object
        }),
        setSelectedCourse: PropTypes.func,
        selectedCourse: PropTypes.shape({
            data: PropTypes.array,
            selected: PropTypes.object
        })
    };

    constructor(props) {
        super(props);
        const i18n = window.i18n;

        this.text = {
            filterSeparatorText: i18n._('Top Level Filter - or'),
            filterDropdownText: i18n._(
                'Top Level Filter - Filter by grade/course'
            ),
            showAllWorkButtonText: i18n._('Top Level Filter - Show all work'),
            contextCurriculumText: i18n._('Top Level Filter - Curriculum'),
            contextGradeCourseText: i18n._('Top Level Filter - Grade/Course'),
            contextShowText: i18n._('Top Level Filter - Show')
        };

        this.state = {
            showAllWorkToggle: false,
            hasSetInitialShowAllWorkToggle: false,
            showContextModal: false,
            tempFilterValues: null
        };
    }

    componentWillReceiveProps(nextProps) {
        this.manageNullDefaultCourse(nextProps);
    }

    manageNullDefaultCourse = (nextProps) => {
        const { skillQuestsMasteryStudentData } = nextProps;
        const { hasSetInitialShowAllWorkToggle } = this.state;
        if (skillQuestsMasteryStudentData) {
            const {
                selectedPublicationCourseId,
                selectedCourseId
            } = skillQuestsMasteryStudentData;
            const hasDefaultCourse =
                selectedCourseId && selectedPublicationCourseId;

            if (!hasDefaultCourse && !hasSetInitialShowAllWorkToggle) {
                this.setState({
                    showAllWorkToggle: true,
                    hasSetInitialShowAllWorkToggle: true
                });
            }
        }
    };

    /**
     * SHOW ALL WORK
     */
    onShowAllWorkClick = () => {
        const { showAllWorkToggle } = this.state;
        const {
            activeFilters,
            getStudentSkillQuestsMasteryDataCourse,
            assignmentResultType
        } = this.props;
        const updatedShowAllWorkToggle = !showAllWorkToggle;

        this.setState({
            showAllWorkToggle: updatedShowAllWorkToggle,
            showContextModal: false
        });

        getStudentSkillQuestsMasteryDataCourse(
            activeFilters[SELECTED_CLASS].id,
            activeFilters[SELECTED_STUDENT].id,
            activeFilters[SELECTED_DATE],
            null,
            null,
            assignmentResultType
        );
    };

    getShowAllWorkButtonProps = () => {
        const { showAllWorkToggle } = this.state;
        const selectedState = {
            className: `${css['work-button']} ${css.selected}`,
            icon: TickIcon
        };
        const unselectedState = {
            className: `${css['work-button']}`
        };

        return showAllWorkToggle ? selectedState : unselectedState;
    };

    /**
     * GRADE FILTER
     */
    getGradeFilterLabel = () => {
        const { showAllWorkToggle } = this.state;
        const { selectedCourse } = this.props;
        const { filterDropdownText } = this.text;
        const shouldUpdatedFilterLabel =
            selectedCourse && selectedCourse.selected && !showAllWorkToggle;

        let updatedGradeFilterLabel = filterDropdownText;

        if (shouldUpdatedFilterLabel) {
            updatedGradeFilterLabel = selectedCourse.selected.name;
        }

        return updatedGradeFilterLabel;
    };

    getGradeFilterButtonText = () => {
        const gradeFilterLabel = this.getGradeFilterLabel();

        return (
            <div
                className={css.text}
                key="grade-filter-button"
                title={gradeFilterLabel}
            >
                {gradeFilterLabel}
            </div>
        );
    };

    onGradeFilterClickHandler = () => {
        const { selectedPublication, selectedCourse } = this.props;

        this.setState({ showContextModal: !this.state.showContextModal });
        this.setState({
            tempFilterValues: {
                curriculum: selectedPublication,
                course: selectedCourse
            }
        });
    };

    /**
     * CONTEXT MODAL
     */
    renderContextModalDropdown = (
        title,
        options,
        selectedOption,
        onSelectOption,
        isDisabled
    ) => (
        <div className={css['dropdown-container']}>
            <span className={css['dropdown-header']}>{title}</span>
            <DropdownMenu
                className={css['context-dropdown']}
                options={options}
                selectedOption={selectedOption}
                onSelectOption={(e) => onSelectOption(e)}
                disabled={isDisabled}
            />
        </div>
    );

    onClickOutsideHandler = () => {
        const { setSelectedPublication, setSelectedCourse } = this.props;
        const {
            tempFilterValues: { course, curriculum }
        } = this.state;

        this.setState({ showContextModal: false });

        setSelectedPublication(curriculum.data, curriculum.selected.id);
        setSelectedCourse(course.data, course.selected.id);
    };

    onSelectCurriculum = (e) => {
        const {
            // todo: consistent naming
            setSelectedPublication,
            setSelectedCourse,
            selectedPublication
        } = this.props;

        setSelectedPublication(selectedPublication.data, e.id);
        setSelectedCourse(e.courses, e.courses[0].id);
    };

    onSelectCourse = (e) => {
        const { setSelectedCourse, selectedCourse } = this.props;

        setSelectedCourse(selectedCourse.data, e.id);
    };

    onContextModalShowClick = () => {
        const {
            activeFilters,
            selectedCourse,
            getStudentSkillQuestsMasteryDataCourse,
            assignmentResultType
        } = this.props;
        const updatedShowAllWorkToggle = false;

        this.setState({
            showContextModal: false,
            showAllWorkToggle: updatedShowAllWorkToggle,
            tempFilterValues: null
        });

        getStudentSkillQuestsMasteryDataCourse(
            activeFilters[SELECTED_CLASS].id,
            activeFilters[SELECTED_STUDENT].id,
            activeFilters[SELECTED_DATE],
            selectedCourse.selected.id,
            selectedCourse.selected.version,
            assignmentResultType
        );
    };

    isContextModalShowDisabled = () => {
        const { selectedCourse } = this.props;

        return selectedCourse.selected.value === DEFAULT_VALUES.COURSES;
    };

    render() {
        const {
            selectedPublication,
            selectedCourse,
            skillQuestsMasteryStudentData
        } = this.props;
        const {
            filterSeparatorText,
            showAllWorkButtonText,
            contextCurriculumText,
            contextGradeCourseText,
            contextShowText
        } = this.text;
        const { showContextModal } = this.state;
        const hasDefaultCourse = selectedPublication && selectedCourse;
        const isGradeFilterEnabled =
            hasValidCourses(skillQuestsMasteryStudentData) && hasDefaultCourse;
        const shouldShowContextModal = showContextModal && hasDefaultCourse;

        return (
            <div className={css['filter-container']}>
                <Button
                    text={showAllWorkButtonText}
                    onClick={this.onShowAllWorkClick}
                    {...this.getShowAllWorkButtonProps()}
                />
                <p className={css.separator}>{filterSeparatorText}</p>
                <Button
                    text={this.getGradeFilterButtonText()}
                    className={css['filter-button']}
                    onClick={this.onGradeFilterClickHandler}
                    icon={UpArrowIcon}
                    alignIcon={'RIGHT'}
                    disabled={!isGradeFilterEnabled}
                />
                <div className={css.border} />
                <ContextModal
                    className={css['filter-context-modal']}
                    show={showContextModal}
                    onClickOutsideHandler={this.onClickOutsideHandler}
                >
                    {shouldShowContextModal && (
                        <div className={css['filters-modal']}>
                            {this.renderContextModalDropdown(
                                contextCurriculumText,
                                selectedPublication.data,
                                selectedPublication.selected,
                                this.onSelectCurriculum,
                                false
                            )}
                            {this.renderContextModalDropdown(
                                contextGradeCourseText,
                                selectedCourse.data,
                                selectedCourse.selected,
                                this.onSelectCourse,
                                selectedPublication.selected.id ===
                                    DEFAULT_VALUES.PUBLICATION
                            )}
                            <Button
                                className={css['dropdown-button']}
                                text={contextShowText}
                                onClick={this.onContextModalShowClick}
                                disabled={this.isContextModalShowDisabled()}
                            />
                        </div>
                    )}
                </ContextModal>
            </div>
        );
    }
}

export default styleable(css)(TopLevelFilter);



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/components/top-level-filter/top-level-filter.js